export default "__VITE_ASSET__hmiqHkW___"